module.exports = __webpack_public_path__ + "static/media/phd_kagarama1.77d56ff3.jpg";